import { render, staticRenderFns } from "./PlatformAnalyticsSummary.vue?vue&type=template&id=b193bcfa&scoped=true"
import script from "./PlatformAnalyticsSummary.vue?vue&type=script&lang=js"
export * from "./PlatformAnalyticsSummary.vue?vue&type=script&lang=js"
import style0 from "./PlatformAnalyticsSummary.vue?vue&type=style&index=0&id=b193bcfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b193bcfa",
  null
  
)

export default component.exports